import { cn } from "@/lib/utils"

interface PageContainerProps {
  children: React.ReactNode
  className?: string
  /** Quita el padding interno cuando la página renderiza su propio container */
  noPadding?: boolean
}

/**
 * Contenedor estándar de página: max-width, padding responsive, vertical rhythm.
 */
export default function PageContainer({
  children,
  className,
  noPadding = false,
}: PageContainerProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-7xl",
        !noPadding && "px-4 py-4 sm:px-6 sm:py-6 md:py-8 space-y-6 md:space-y-8",
        className
      )}
    >
      {children}
    </div>
  )
}
